module.exports = __webpack_public_path__ + "img/xmasParty8.8f5b73a1.jpg";